"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function NuestraHistoria() {
  const {
    ref: heroRef,
    isVisible: heroVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="nuestra-historia" ref={heroRef} className="relative min-h-screen w-full flex items-center justify-center overflow-hidden bg-cover bg-center !bg-[url(https://wise-hagfish.10web.cloud/wp-content/uploads/2026/02/image_trbhsaby.webp)] py-48">
      

      <div className={`relative z-10 container text-center transition-all duration-1000 ${heroVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h1 className="font-serif text-5xl font-bold py-12 mb-6 leading-tight tracking-tight !text-[hsl(48,100%,96%)] md:text-6xl lg:text-7xl">Auténtico aceite de oliva de Granada</h1>

        <p className="text-white/95 mb-10 max-w-2xl mx-auto leading-relaxed !text-xl">Para tiendas, degustaciones y amantes del aceite de oliva con carácter.</p>

        <Link to="#nuestro-aceite">
          <Button className="btn">Solicitar información</Button>
        </Link>
      </div>

    </section>;
}